module.exports = __webpack_public_path__ + "static/media/01.08.77e47071.webp";